<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data: () => ({}),
  computed: {
    ...mapState({
      message: (state) => state.alerts.message,
    }),
  },
  watch: {
    message(newValue) {
      const { message, type } = newValue;
      if (type !== "info") {
        this.$toast.open({
          message: message,
          type: type,
          duration: 5000,
          position: "top-right",
        });
      } else {
        this.$toast.open({
          message: message,
          type: type,
          duration: 5000,
          position: "top",
        });
      }
    },
  },
};
</script>

<style>
/*.colForm {
  padding-left: 5px !important;
  padding-right: 5px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}*/
</style>
